// src/ForceLogoutRedirect.js
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const ForceLogoutRedirect = () => {
  useEffect(() => {
    localStorage.clear();
  }, []);

  return <Navigate to="/login" replace />;
};

export default ForceLogoutRedirect;

